export default __webpack_public_path__ + "static/media/Mariana.12f2d6d1.png";